import React, { Component } from 'react';
// utils
import queryString from 'query-string';
// styles
import styles from './Page404.mod.css';

class Page404 extends Component {
  constructor(props) {
    super(props);
    const {
      location: { search }
    } = props;
    const query = queryString.parse(search);
    this.state = {
      message:
        query.message || `We couldn’t find the page you are looking for...`
    };
  }

  render() {
    const { message } = this.state;

    return (
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <h1>{message}</h1>
          <p>
            but remember:<br />
            “If you can quit for a day, you can quit for a lifetime.”
          </p>
        </div>
      </div>
    );
  }
}

export default Page404;



// WEBPACK FOOTER //
// ./src/containers/Page404/Page404.jsx